pageId = 'tencent_docs-documents-show'

$(document).on "pjaxload##{ pageId }", (e, $page, page) ->
  tower.adjustAuthor()
  tower.adjustAttachment()
  tower.adjustProjInfo()
  tower.adjustCommentsLike()
  tower.foldComments()
  tower.foldEvents()
